export const BASE_URL =
  //  "https://backend.icipl.co/public/api/crm/"; //SIT live;
  // "http://192.168.0.21/icipl-superadmin-backend-script/public/api/crm"; //local
  // "https://uatbackend.icipl.co/public/api/crm/"; //UAT
  // "https://backend-icipl.ninositsolution.com/public/api/crm/"; //UAT NEW
  // "https://sit-icipl-backend.ninositsolution.com/public/api/crm/"; //SIT NEW
  "https://backendscript.icipl.co/public/api/crm/"; // Production

export const URLS = {
  LOGIN: "login",
  LOGOUT: "logout",
  ADMINLIST: "admin/list",
  ADMINADD: "admin/add",
  ADMINEDIT: "admin/update/",
  ADMINVIEW: "admin/show/",
  ADMINSTATUS: "admin/status/",
  REGIONLIST: "region-list",
  REGIONAL_REGIONLIST: "/unassigned-region",
  MASTERLIST: "masters/list",
  MASTERADD: "masters/add",
  MASTERUPDATE: "masters/update/",
  MASTERSTATUS: "masters/status/",
  REGIONAL_MANAGER_SELECTED: "regions-with-managers",
  LOCATIONLIST: "list-location",
  STORE_LOCATION: "store-location",
  UPDATELOCATION: "update-location/",
  TICKET_LIST: "tickets/list",
  TICKET_VIEW: "tickets/view/",
  TICKET_CLOSE: "tickets/update/",
  CUSTOMERS_LIST: "customers/list-customer",
  SAMPLE_DATE_EXCEL_DOWNLOAD: "sample-download",
  IMPORT_CUSTOMER: "customers/import",
  INVENTORY_LIST: "inventory-list",
  TECHNICAL_LIST: "technical-list",
  DEPARTMENT_LIST: "department-list",
  DASHBOARD_LIST: "dashbord",
  REGIONAL_MANAGERS: "region-users",
  REGION_REPORT: "report/list",
  SERVICE_ENGINEER_LIST: "service-engineer-list",
  OVERALL_TICKET: "overall-ticket-list",
  OVERALL_CUSTOMER_LIST: "overall-customer-list",
  FAULT_LIST: "fault-list",
  NOTICATION: "notification/list",
  OVERALL_SERVICE_LIST: "/admin/service-managers-list",
  OVERALL_PRINTER_LIST: "/list-printers",
};

export const TOKEN = "token";
export const LOGGEDUSER = "loggeduser";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";
export const LOCATION = "userlocation";
export const LOCATIONNAME = "locationname";
export const GOOGLE_MAP_KEY = "AIzaSyAJJyn2YN6kCvs3XxEMC9XIhB1xPGjkBW4";
export const OLA_MAP_KEY = "lcndCmgsSIcmietX3bkCGIFMG1ijjKwLkDA0ZeCK";

export const PASS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*.?&])[A-Za-z\d@$!%.*?&]{8,}$/;
export const isValidEmail = (email) => {
  return EMAIL.test(email);
};
export const NUMBER = /^[6-9]\d{9}$/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const logger = (obj) => {
  if (
    typeof obj == "string" ||
    typeof obj == "number" ||
    typeof obj == "boolean"
  ) {
    console.log(obj, obj.toString());
  } else {
    for (const [key, value] of Object.entries(obj)) {
      console.log(`${key}:`, value);
    }
  }
};

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};

export const configJodit = {
  activeButtonsInReadOnly: ["source", "fullsize", "print", "about", "dots"],
  buttons: [
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "ul", // Unordered list
    "ol", // Ordered list
    "|",
    "fontsize",
    "font",
    "brush", // Text color & background color
    "paragraph", // Format block (Headings)
    "lineHeight", // Line height adjustment
    "align",
    "dots",
  ],
  toolbarSticky: false, // Keeps toolbar flexible
  toolbarAdaptive: true, // Ensures responsiveness
  toolbarButtonSize: "small", // Makes buttons smaller on small screens
  // height: "auto", // Auto height for responsiveness
  // minHeight: 200, // Prevents the editor from collapsing
  spellcheck: true,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  showPlaceholder: false,
};

// regular expressions to validate password
